import {Injectable} from "@angular/core";
import {CerbaCookieService} from "./cerbacookie.service";
import { CookieConstantes } from "@digicerba/common/constantes/cookie.constantes";

@Injectable()
export class CerbaAuthService {

    private tokenAutenticationHeader: string;
    private tokenCorrespondantHeader: string;

    constructor(private cookieService: CerbaCookieService) {
        console.log("Load CerbaAuthService");
    }

    redirectToLogin(): void {
        this.cookieService.removeAll();
        let url = '/authentification/login_en.html?redirect=';
        if (navigator.language.startsWith("fr")) {
            url = '/authentification/login.html?redirect=';
        }
        url += encodeURIComponent(window.location.href);
        window.location.href = url;
    }

    logout(): void {
        this.cookieService.removeCoockie(CookieConstantes.COOKIE_AUTH);
        this.cookieService.removeCoockie(CookieConstantes.COOKIE_CORRESPONDANT);
        this.setTokenAuthenticationHeader(null);

        let url = '/authentification/login_en.html';
        if (navigator.language.startsWith("fr")) {
            url = '/authentification/login.html';
        }
        
        window.location.href = url;
    }

    unauthorized(status: any): void {
        if (status === 410) {
            window.location.reload(true);
        } else {
            let domain = window.location.hostname;
            let destDomain = window.location.hostname;
            destDomain = destDomain.substring(destDomain.indexOf(".") + 1);
            destDomain = 'www.' + destDomain;
            let url = window.location.href;
            url = url.replace(domain, destDomain);
            window.location.href = url;
        }
    }

    setTokenAuthenticationHeader(value: string) {
        this.tokenAutenticationHeader = value;
    }

    getTokenAuthenticationHeader() {
        return this.tokenAutenticationHeader;
    }

    setTokenCorrespondantHeader(value: string) {
        this.tokenCorrespondantHeader = value;
    }

    getTokenCorrespondantHeader() {
        return this.tokenCorrespondantHeader;
    }
}



// WEBPACK FOOTER //
// /home/vsts/work/1/s/digicerba-modules/digicerba-common-module/src/services/auth.service.ts